export default __webpack_public_path__ + "static/media/add-button.561d999b.svg";